import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "../../api/request";

export const apiSlice = createApi({
  baseQuery: axiosBaseQuery as any,
  reducerPath: "api",
  tagTypes: [],
  keepUnusedDataFor: 300, // Keep unused data in cache for 5 minutes
  refetchOnMountOrArgChange: 30, // Refetch when component mounts or args change after 30 seconds
  refetchOnFocus: true, // Refetch when window regains focus
  refetchOnReconnect: true, // Refetch when network reconnects
  endpoints: () => ({}),
});

export default apiSlice;
